import { crux_bolt_display_page_type_e } from "@WahooFitness/crux-js-display-cfg";

export const playrFieldMaxDefaults: Record<number, number> = {
  [crux_bolt_display_page_type_e.BOLTAPP_WORKOUT]: 11,
  [crux_bolt_display_page_type_e.BOLTAPP_LAP]: 11,
  [crux_bolt_display_page_type_e.BOLTAPP_MAP]: 3,
  [crux_bolt_display_page_type_e.BOLTAPP_KICKR]: 5,
  [crux_bolt_display_page_type_e.BOLTAPP_ZOOM]: 11, // custom pages
  [crux_bolt_display_page_type_e.PLAYR_SIMULATED_ROUTE]: 4,
  [crux_bolt_display_page_type_e.PLAYR_HR_ZONE]: 11,
  [crux_bolt_display_page_type_e.PLAYR_POWER_ZONE]: 11,
  [crux_bolt_display_page_type_e.PLAYR_PACE_ZONE]: 11,
  [crux_bolt_display_page_type_e.PLAYR_AVERAGES]: 11,
  [crux_bolt_display_page_type_e.PLAYR_RUNNING_DYNAMICS]: 5,
};

export const PLAYR_DEFAULT_ID = 999;
